import { BulkOperations } from '@openx/components-header/BulkOperations/BulkOperations';
import { PackageRowActionType } from '@openx/components-package/types';
import { usePackageOperations } from '@openx/components-package/utils/hooks/usePackageOperations';
import { ACL_TYPE } from '@openx/types/aclType';
import type { PackageListItem } from '@openx/types/package';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext';
import { isAllowedByCompiledAcl } from '@openx/utils/permission/validators';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

type PackagesBulkOperationsProps = {
  selectedPackages: PackageListItem[];
  closeAndUnselect: () => void;
};

export const PackagesBulkOperations = ({
  selectedPackages,
  closeAndUnselect,
}: PackagesBulkOperationsProps): JSX.Element => {
  const { useIsAllowed } = usePermissionContext();
  const { isAllowed } = useIsAllowed();
  const { t } = useTranslation();
  const { callPackageAction, loadingAction } = usePackageOperations();

  return (
    <BulkOperations
      selectedItems={selectedPackages}
      actions={[
        {
          color: 'error',
          disabled: !!loadingAction,
          isAllowed: isAllowed(isAllowedByCompiledAcl(ACL_TYPE.PACKAGE_DELETE)),
          label: t('Delete'),
          loading: loadingAction === PackageRowActionType.DELETE,
          onClick: () => {
            callPackageAction({
              action: PackageRowActionType.DELETE,
              isBulkMode: true,
              onFinish: () => closeAndUnselect(),
              packages: selectedPackages,
            });
          },
        },
        {
          color: 'secondary',
          disabled: !!loadingAction,
          isAllowed: isAllowed(isAllowedByCompiledAcl(ACL_TYPE.PACKAGE_CREATE)),
          label: t('Clone'),
          loading: loadingAction === PackageRowActionType.CLONE,
          onClick: () => {
            callPackageAction({
              action: PackageRowActionType.CLONE,
              isBulkMode: true,
              onFinish: () => closeAndUnselect(),
              packages: selectedPackages,
            });
          },
        },
      ]}
      onClose={() => closeAndUnselect()}
    />
  );
};
